/* eslint no-console: 0 */
import mode from "./mode";

/**
 * The Logger class provides a simple but sophisticated logging utility that
 * you can use to output messages.  The messages have associated levels, such
 * as log, warn or error that indicate their importance.
 * Disabled by default you can enable them by query string:
 *
 *  - `http://localhost:8081/examples/?logger=all` enables all
 *  - `http://localhost:8081/examples/?logger=renderer,ajax` enables renderer and ajax loggin messages
 *
 *  All modules should start with the following snippet:
 *
 * ```js
 *  import Logger from './Logger';
 *  const console = new Logger(__filename);
 *  console.log('load');
 *  ```
 *
 */
class Logger {
  /**
   * @param {string} name name
   * @param {string} color color
   * @param {bool} active active
   */
  constructor(name, color = "#d9edf7", active = true) {
    this.name = name;
    this.color = color;
    this.active = active;

    if (!active && mode("logger")) {
      if (mode("logger", "all")) {
        this.active = true;
      } else {
        const re = new RegExp(mode.query.logger.split(",").join("|"), "i");
        this.active = re.test(this.name);
      }
    }
  }

  log(msg) {
    this.print(this.name, msg, this.color, "info");
  }

  warn(msg) {
    this.print(this.name, msg, "#fcf8e3", "warn");
  }

  error(msg) {
    this.print(this.name, msg, "#f2dede", "error");
  }

  print(name, msg, bg, type) {
    msg = `${name}: ${msg}`;
    if (process.env.NODE_ENV !== "production") {
      if (this.active) {
        console[type](msg);
      }
    }

    const logger = document.getElementById("logger");
    if (logger) {
      const div = document.createElement("div");
      div.style.background = bg;
      const textNode = document.createTextNode(msg);
      div.appendChild(textNode);
      logger.appendChild(div);
    }
  }

  debug(...msg) {
    if (process.env.NODE_ENV !== "production") {
      window.console.debug(this.name, ...msg);
    }
  }
}

export default Logger;
